<template>
  <div class="about">
    <h2>Process `{{ knowledge_process.name }}` <small>id:{{ $route.params.knowledge_process_id }}</small></h2>

    <div class="loading" v-if="loading">
        Loading...
    </div>
    <div v-if="error" class="error">
      {{ error }}
    </div>
    <div v-if="knowledge_process" class="content">
        <KnowledgeProcessDetails :knowledge_process=knowledge_process />
    </div>
    <Turtle @edit_click="toggle_edit" @add_btn_click="add_btn_click" @detail_btn_click="detail_btn_click" :knowledge_items="knowledge_items" :knowledge_process="knowledge_process" />

    <div v-if="false">
    <KnowledgeItemForm :form=new_item :submit_handler=new_knowledge_item_submit :questionnaires="questionnaires" />
    <div class="process_items">
        <b-card v-for="item in knowledge_items" :title="item.title" :sub-title="get_human_group(item.group)" style="margin-bottom: 10px">
            <span class="card-text description">{{ item.description }}</span>
            <div v-if="item.questionnaire">
                <strong>Questionnaire:</strong> {{ item.questionnaire.name }}<br />{{ item.questionnaire.description }}
            </div>
            <b-button @click="toggle_delete(item)" variant="danger" class="float-right" style="margin-left: 10px;">Delete</b-button>
            <b-button @click="toggle_edit(item)" variant="primary" class="float-right">Edit</b-button>
        </b-card>
    </div>
    </div>

    <b-jumbotron style="margin-top: 20px" header="No risks" lead="Please add risks to fill the knowledge base" v-if="knowledge_items.length < 1"></b-jumbotron>

    <b-modal title="Risk item" @ok="handleOk" ref="editModal" size="huge">
        <KnowledgeItemForm :form=edit_item :submit_handler=edit_knowledge_item_submit :hide_submit="true" :questionnaires="questionnaires" />
    </b-modal>

    <b-modal :title="get_human_group(detail_modal.group)" ref="detailModal" size="huge">
        <b-card v-for="item in get_items(detail_modal.group)" :title="item.title" :sub-title="get_human_group(item.group)" style="margin-bottom: 10px">
            <span class="card-text description">{{ item.description }}</span>
            <br />
            <strong>Questionnaires:</strong><br />
            <div v-for="questionnaire in item.questionnaires">
                {{ questionnaire.name }} {{ questionnaire.description }}
            </div>
            <b-button @click="toggle_delete(item)" variant="danger" class="float-right" style="margin-left: 10px;">Delete</b-button>
            <b-button @click="toggle_edit(item)" variant="primary" class="float-right">Edit</b-button>
        </b-card>
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios';
import KnowledgeProcessDetails from '@/components/KnowledgeProcessDetails.vue'
import KnowledgeItemForm from '@/components/KnowledgeItemForm.vue'
import Turtle from '@/components/Turtle.vue'

export default {
  data () {
    return {
        loading_processes: false,
        loading_questionnaires: false,
        post: null,
        knowledge_process: {},
        knowledge_items: [],
        new_item: {
            group: '',
            title: '',
            description: '',
            questionnaire_id: null,
            questionnaires: []
        },
        edit_item: {
            group: '',
            title: '',
            description: '',
            knowledge_item_id: -1,
            questionnaire_id: null,
            questionnaires: []
        },
        detail_modal: {
            group: ''
        },
        questionnaires: []
    }
  },
  components: {
      KnowledgeProcessDetails,
      KnowledgeItemForm,
      Turtle
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  computed: {
      loading() {
          return this.loading_processes || this.loading_questionnaires;
      }
  },
  methods: {
      get_items(group) {
          return this.knowledge_items.filter(function (e) {
              return e.group == group;
          });
      },
      toggle_delete(item) {
          this.$http.delete('/v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items/' + item.knowledge_item_id).then(response => {
              this.fetchData();
          });
      },
      get_human_group(group) {
          var table = {
              process_input: 'Process input',
              process_management: 'Process management',
              personnel_resources: 'Personnel resources',
              material_resources: 'Material resources',
              efficiency: 'Efficiency',
              process_output: 'Process output'
          }
          return table[group];
      },
      handleOk() {
          if (this.edit_item.knowledge_item_id != null && this.edit_item.knowledge_item_id > 0) {
            this.$http.put('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items/' + this.edit_item.knowledge_item_id, this.edit_item).then(response => {
                this.fetchData()
            });
          }
          else {
              this.$http.post('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items', this.edit_item).then(response => {
              this.knowledge_items.push(response.data.response);
              this.reset_new_knowledge_base_form();
          });
          }
      },
      fetchData() {
          this.error = this.post = null;
          this.loading_processes = true;
          this.loading_questionnaires = true;
          this.$http.get('v1/kb/1/processes/' + this.$route.params.knowledge_process_id).then(response => {
              this.knowledge_process = response.data.response.knowledge_process;
              this.knowledge_items = response.data.response.knowledge_items
              this.loading_processes = false;
          });

          this.$http.get('v1/questionnairecatalogues/1').then(response => {
              this.questionnaires = response.data.response
              this.loading_questionnaires = false;
          });
      },
      new_knowledge_item_submit() {
          this.$http.post('v1/kb/1/processes/' + this.$route.params.knowledge_process_id + '/items', this.new_item).then(response => {
              this.knowledge_items.push(response.data.response);
              this.reset_new_knowledge_base_form();
          });
      },
      reset_new_knowledge_base_form() {
          this.new_item.group = '';
          this.new_item.title = '';
          this.new_item.description = '';
      },
      edit_knowledge_item_submit() {
          console.log("jslkfjdslf");
      },
      toggle_edit(item) {
          this.edit_item.group = item.group;
          this.edit_item.title = item.title;
          this.edit_item.description = item.description;
          this.edit_item.knowledge_item_id = item.knowledge_item_id;
          this.edit_item.questionnaire_id = item.questionnaire_id;
          this.edit_item.questionnaires = item.questionnaires;
          this.$refs.editModal.show();
      },
      add_btn_click(group) {
          console.log("this.$refs.editModal.show();this.$refs.editModal.show();this.$refs.editModal.show();");
          this.edit_item.group = group;
          this.edit_item.title = '';
          this.edit_item.description = '';
          this.edit_item.knowledge_item_id = null;
          this.edit_item.questionnaire_id = null;
          this.edit_item.questionnaires = [];
          this.$refs.editModal.show();
      },
      detail_btn_click(group) {
          console.log("--", group);
          this.detail_modal.group = group;
          this.$refs.detailModal.show();
      }
  }
}
</script>
<style>
small {
    color: gray;
}
.description {
  white-space: pre-wrap; 
  word-wrap: break-word;
  font-family: inherit;
}
.edit-btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
}
.process_items {
    margin-top: 20px;
}
.modal-huge {
    max-width: 80%;
    width: 80%;
}
</style>
